import { PortalLanguages } from '../configs/PortalConfig';

export enum RoutePermissionType {
  Dashboard = 'dashboard',
  AuditTrail = 'auditTrail',
  DevicesReport = 'devicesReport',
  ESimManager = 'eSimManager',
  UemList = 'uemList',
  UemCreate = 'uemCreate',
  CompaniesList = 'companiesList',
  CompaniesCreate = 'companiesCreate',
  CompaniesEdit = 'companiesEdit',
  AdminsList = 'adminsList',
  AdminsCreate = 'adminsCreate',
  Import = 'import',
  NewConnection = 'newConnection',
  EditDevices = 'editDevices',
  EditUsers = 'editUsers',
  Transactions = 'transactions',
  AssignDevices = 'assignDevices',
  UnassignedDeviceList = 'unassignedDeviceList',
  UsersCreate = 'usersCreate',
  DevicesCreate = 'devicesCreate',
  Banners = 'banners',
}

export enum FeaturePermissionType {
  SelectCompanyAuditTrail = 'selectCompanyAuditTrail',
  SelectCountriesAuditTrail = 'selectCountriesAuditTrail',
  UserDevicesActions = 'userDevicesActions',
}

export interface Role {
  role: string;
  translations: {
    [key in PortalLanguages]: string;
  };
}

export interface RoleTranslations {
  [key: string]: string;
}

export enum ExportConfigsType {
  AuditTrailReport = 'auditTrailReport',
  UsersReport = 'usersReport',
  DevicesReport = 'devicesReport',
  TransactionsReport = 'transactionsReport',
}

export interface ExportConfig {
  exportMaxNumberOfRows: number;
}

export interface PortalConfig {
  featurePermissions: {
    [key in FeaturePermissionType]: string[];
  };
  routePermissions: {
    [key in RoutePermissionType]: string[];
  };
  roles: Role[];
  configs: {
    [key in ExportConfigsType]: ExportConfig;
  };
}

export type PortalConfigResponse = PortalConfig;
